<ng-container *appLoad="let insight of insight$; trackingName: 'lead-insight'">
  <app-insight-card [heading]="(insight.value | plural: 'Lead' : 'Leads')" [change]="insight.change" text="Received this month">
  </app-insight-card>
</ng-container>